import { FC, useEffect } from "react";
import { SimpleSouthKoreaMapChart } from "react-simple-south-korea-map-chart";

const MainKoreaMap: FC = () => {
  useEffect(() => {
    const svg = document.querySelector(".svg-map") as SVGElement;
    if (svg) {
      svg.removeAttribute("height");
      svg.style.height = "100%";
      svg.style.maxHeight = "320px";
      svg.style.display = "block";
    }
  }, []);

  const data = [
    { locale: "부산광역시", count: 15 },
    { locale: "대구광역시", count: 30 },
    { locale: "대전광역시", count: 4 },
    { locale: "강원도", count: 25 },
    { locale: "광주광역시", count: 10 },
    { locale: "경기도", count: 41 },
    { locale: "인천광역시", count: 22 },
    { locale: "제주특별자치도", count: 1 },
    { locale: "충청북도", count: 4 },
    { locale: "경상북도", count: 21 },
    { locale: "전라북도", count: 33 },
    { locale: "세종특별자치시", count: 1 },
    { locale: "충청남도", count: 0 },
    { locale: "경상남도", count: 0 },
    { locale: "전라남도", count: 2 },
    { locale: "울산광역시", count: 1 },
    { locale: "서울특별시", count: 124 },
  ];

  const setColorByCount = (count: number) => {
    if (count === 0) return "#F1F1F1";
    if (count > 200) return "#79D3C4";
    if (count > 100) return "#43cdb6";
    if (count > 40) return "#61CDBB";
    if (count > 20) return "#91D9CD";
    if (count > 10) return "#A9DFD6";
    if (count > 5) return "#C1E5DF";
    if (count > 0) return "#D9EBE8";
    else return "#ebfffd";
  };

  const CustomTooltip = ({ darkMode, tooltipStyle, children }: any) => {
    return (
      <div
        style={{
          color: "#fdfd96",
          position: "fixed",
          minWidth: "80px",
          padding: "10px",
          border: `1px solid ${darkMode ? "#3a3a3a" : "#e0e0e0"}`,
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#2c3e50",
          fontSize: "14px",
          lineHeight: "1.4",
          fontWeight: 500,
          ...tooltipStyle,
        }}
      >
        {children}
      </div>
    );
  };

  return (
    <div>
      <div
        className="mainListTitle"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        지역별 가동현황
      </div>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "8px",
          padding: "4px",
        }}
      >
        <SimpleSouthKoreaMapChart
          setColorByCount={setColorByCount}
          data={data}
          customTooltip={<CustomTooltip />}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default MainKoreaMap;
